module.exports = __webpack_public_path__ + "static/media/mell.07d546ca.png";